import { TpAssetInfo, TpAssetUpdateInfo } from '../data/assets/interfaces';
import { getAssetTemplateId } from '../data/templateSlice.helpers';
import { TpOrganizationInfo } from './models/admin';
import { TpTemplateInfo, TpTemplateUpdateInfo } from './models/assets';

export const mapPythonAssetToAssetInfo = (apiAsset: any): TpAssetInfo => {
  const assetInfo: TpAssetInfo = {
    id: apiAsset.id,
    name: apiAsset.name,
    displayName: apiAsset.display_name,
    type: apiAsset.type,
    description: apiAsset.description,
    creationDate: apiAsset.created,
    lastModifiedDate: apiAsset.modified,
    owner: apiAsset.owner,
    isSystemAsset: apiAsset.is_system_asset ?? false,
    tags: apiAsset.tags,
    relations: [],
    properties: apiAsset.properties,
  };
  if (assetInfo.properties && assetInfo.properties['templates']) {
    const assetTemplates = assetInfo.properties['templates'];
    if (assetTemplates['dashboard_template']) {
      const template: TpTemplateInfo = {
        name: assetInfo.name,
        displayName: assetInfo.displayName,
        scope: 'dashboard',
        templateType: assetInfo.type,
        yamlString: assetTemplates['dashboard_template'],
        isActive: true,
        isSystem: false,
        isDefault: true,
        assetId: assetInfo.id,
        id: getAssetTemplateId(assetInfo.id, 'dashboard'),
      };
      assetInfo.assetDashboardTemplate = template;
    }
    if (assetTemplates['entity_template']) {
      const template: TpTemplateInfo = {
        name: assetInfo.name,
        displayName: assetInfo.displayName,
        scope: 'entity',
        templateType: assetInfo.type,
        yamlString: assetTemplates['entity_template'],
        isActive: true,
        isSystem: false,
        isDefault: true,
        assetId: assetInfo.id,
        id: getAssetTemplateId(assetInfo.id, 'entity'),
      };
      assetInfo.assetEntityTemplate = template;
    }
  }
  return assetInfo;
};

export const mapAssetUpdateInfoToPythonAsset = (asset: TpAssetUpdateInfo): any => {
  const apiAsset = {
    display_name: asset.displayName,
    description: asset.description,
  };
  return apiAsset;
};

export const mapPythonOrganizationToOrganizationInfo = (apiOrganization: any): TpOrganizationInfo => {
  const organizationInfo: TpOrganizationInfo = {
    identifier: apiOrganization.identifier,
    name: apiOrganization.organization_name,
    isActive: apiOrganization.is_active,
    organizationPrefix: apiOrganization.organization_prefix,
    pluginIds: apiOrganization.plugin_ids,
  };
  if (apiOrganization.users) {
    organizationInfo.users = apiOrganization.users.map((user: any) => {
      return {
        email: user.email,
        organizationId: apiOrganization.id,
        userId: user.identifier,
      };
    });
  }
  return organizationInfo;
};

export const mapTemplateInfoToPythonTemplate = (template: Partial<TpTemplateInfo>): any => {
  const apiTemplate = {
    name: template.name,
    display_name: template.displayName,
    version: template.version,
    template_type: template.templateType,
    scope: template.scope,
    yaml_string: template.yamlString,
    is_active: template.isActive,
  };
  return apiTemplate;
};

export const mapTemplateUpdateInfoToPythonTemplate = (template: TpTemplateUpdateInfo): any => {
  const apiTemplate = {
    yaml_string: template.yamlString,
    display_name: template.displayName,
    version: template.version,
    is_active: template.isActive,
  };
  return apiTemplate;
};
